import React from 'react';
import { Dashboard } from './components/Dashboard';
export function App() {
  return <div className="w-full min-h-screen bg-background" data-id="element-0">
      <Dashboard data-id="element-1" />
    </div>;
}